import React from 'react';
import ReactDOM from 'react-dom';

const CreateOrEditExistingModal = ({
  show,
  onClose,
  onCreateNew,
  onEditExisting,
  title = 'Profile Exists',
  subtitle = 'You already have a profile of this type. What would you like to do?',
  createLabel = 'Create New',
  editLabel = 'Edit Existing',
}) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="modal visible">
      <div className="modal__overlay" onClick={onClose}></div>
      <div className="modal__content">
        <button className="button no-style close" onClick={onClose}>
          <img src="/assets/icon--close-CN6QlgAA.svg" alt="Close" />
        </button>
        <div className="modal__form">
          <div className="content">
            <h2>{title}</h2>
            <span className="subtitle">{subtitle}</span>
            <div className="buttons-group">
              <button className="button button-border" onClick={onCreateNew}>{createLabel}</button>
              <button className="button button-black" onClick={onEditExisting}>{editLabel}</button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateOrEditExistingModal;
